<template>
  <div class="LorRbg">
    <div class="w1000 clearfix">
      <div class="LorRright style1">
        <el-tabs v-model="activeName" class="tabcon1">
          <el-tab-pane label="新用户注册" name="first">
            <el-form ref="registerform" :model="registerform" :rules="registerRules">
              <el-form-item prop="mobilePhone">
                <i class="icon icon1"></i>
                <el-input v-model="registerform.mobilePhone" placeholder="手机号（必填）"></el-input>
              </el-form-item>
              <el-form-item class="verification" prop="verCode">
                <i class="icon icon3"></i>
                <el-input v-model="registerform.verCode" placeholder="验证码"></el-input>
                <p class="code" v-show="verShow" @click="getauthcode">获取验证码</p>
                <p class="code gray" v-show="!verShow">重新发送<i>{{timer}}</i>s</p>
              </el-form-item>
              <el-form-item prop="password">
                <i class="icon icon2"></i>
                <el-input v-model="registerform.password" placeholder="密码（必填）" type="password"></el-input>
              </el-form-item>
              <div class="describe">密码要求6-16位，至少包含数字、字母、符号两种元素</div>
              <el-form-item prop="conPassword">
                <i class="icon icon4"></i>
                <el-input v-model="registerform.conPassword" placeholder="确认密码（必填）" type="password"></el-input>
              </el-form-item>
              <!-- <el-form-item prop="email">
                <i class="icon"></i>
                <el-input v-model="registerform.email" placeholder="邮箱"></el-input>
              </el-form-item> -->
              <el-form-item prop="name">
                <i class="icon icon5"></i>
                <el-input v-model="registerform.name" placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item prop="sex">
                <i class="icon icon6"></i>
                <el-select v-model="registerform.sex" placeholder="性别">
                  <el-option label="男" value="男"></el-option>
                  <el-option label="女" value="女"></el-option>
                </el-select>
              </el-form-item>
              <a class="lorbtn" :class="{ active: allinput}" @click="registerbtn">立即注册</a>
              <div class="descbox">完成此注册，即表明了您同意了我们的<a :href="registrationpolicylink" target="_blank">使用条款和隐私策略</a></div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <el-dialog
          title="使用条款和隐私策略"
          :visible.sync="centerDialogVisible"
          width="30%"
          :append-to-body="true"
          center>
          <span>需要注意的是内容是默认不居中的</span>
          <span slot="footer" class="dialog-footer">
    <el-button type="warning" @click="centerDialogVisible = false">确 定</el-button>
  </span>
        </el-dialog>
      </div>
      <div class="LorRleft">
        <div class="codebox" v-if="codeFlag">
          <div class="imgbox">
            <img :src="downloadImg" alt="">
          </div>
          <p>{{ downloadtext }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVERCode, setRegister } from '@/api/user/index'
export default {
  name: 'register',
  meta: {
    showHeader: true
  },
  data () {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(this.$message.error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    const validatePass1 = (rule, value, callback) => {
      const passwordReg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/
      if (!value) {
        return callback(new Error('密码不能为空'))
      }
      setTimeout(() => {
        if (passwordReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的密码格式'))
        }
      }, 100)
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerform.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    // const checkEmail = (rule, value, callback) => {
    //   const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    //   if (!value) {
    //     return callback(new Error('邮箱不能为空'))
    //   }
    //   setTimeout(() => {
    //     if (mailReg.test(value)) {
    //       callback()
    //     } else {
    //       callback(new Error('请输入正确的邮箱格式'))
    //     }
    //   }, 100)
    // }
    return {
      /* tab选项卡默认值 */
      activeName: 'first',
      /* 扫码登录控制 */
      scancodeFlag: true,
      verShow: true,
      registerform: {
        mobilePhone: '',
        password: '',
        conPassword: '',
        name: '',
        // email: '',
        sex: '',
        verCode: ''
      },
      registerRules: {
        mobilePhone: [{required: true, message: '请输入正确的手机号', validator: checkPhone, trigger: 'blur'}],
        password: [{required: true, validator: validatePass1, trigger: 'blur'}],
        conPassword: [{ required: true, trigger: 'blur', validator: validatePass2 }],
        name: [{required: true, message: '姓名不能为空', trigger: 'blur'}, {min: 1, max: 100, message: '长度不能超过100个字符', trigger: 'blur'}],
        // email: [{ required: true, trigger: 'blur', validator: checkEmail }],
        sex: [{required: true, message: '请选择性别', trigger: 'blur'}],
        verCode: [{required: true, message: '验证码不能为空', trigger: 'blur'}]
      },
      timer: 60,
      timers: null,
      centerDialogVisible: false,
      codeFlag: true,
      allinput: false,
      List: [],
      unitName: '',
      registrationpolicylink: '',
      downloadImg: require('@/assets/common/images/ewm.png'),
      downloadtext: '下载学习通'
    }
  },
  watch: {
    'registerform.mobilePhone' (val) {
      if (val && val.length === 11) {
        // this.getPicCode()
      }
    },
    'registerform.verCode' (val) {
      if (val) {
        this.allinput = true
      }
    },
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    }
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  mounted () {
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        if (item.slotCode === 'messagename') {
          this.unitName = item.slotName
        }
        if (item.slotName === 'registrationpolicy') {
          this.registrationpolicylink = item.link
        }
        if (item.slotCode === 'downloadconfig') {
          this.downloadtext = item.slotName
          if (item.imgPath !== undefined && item.imgPath !== '') {
            this.downloadImg = item.imgPath
          }
        }
      })
    },
    getauthcode () {
      if (this.registerform.mobilePhone !== '') {
        this.verShow = false
        let authtimer = setInterval(() => {
          this.timer--
          if (this.timer <= 0) {
            this.verShow = true
            this.timer = 60
            clearInterval(authtimer)
          }
        }, 1000)
        const obj = {'status': 1, 'unitName': this.unitName}
        getVERCode(this.registerform.mobilePhone, obj).then((res) => {
          if (res.data.rel) {
            this.$message({message: res.data.data, type: 'success'})
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        this.$message({message: '请填写手机号', type: 'warning'})
      }
    },
    registerbtn () {
      this.$refs['registerform'].validate((valid) => {
        if (valid) {
          setRegister(JSON.stringify({
            'phone': this.registerform.mobilePhone,
            'password': this.registerform.password,
            'conPassword': this.registerform.conPassword,
            'departmentCode': this.$cookie.get('museumCode'),
            'verCode': this.registerform.verCode,
            'sex': this.registerform.sex,
            // 'email': this.registerform.email,
            'name': this.registerform.name
          })).then((res) => {
            if (res.data.status === 200) {
              this.$message({
                message: '注册成功',
                type: 'success',
                duration: 2000
              })
              if (this.$route.query.redirect) {
                this.timers = setTimeout(() => {
                  this.$router.push({path: '/login', query: {redirect: this.$route.query.redirect}})
                }, 2000)
              } else {
                this.timers = setTimeout(() => {
                  this.$router.push({path: '/login'})
                }, 2000)
              }
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.timers)
    this.timers = null
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/common/scss/_user.scss";
</style>



// WEBPACK FOOTER //
// src/view/user/register.vue